/**
 * Created by andreaskarantzas on 05.05.20.
 */
import { makeAutoObservable, observable, ObservableMap } from 'mobx';
import { v4 as UUID } from 'uuid';
import { NativeFeedComponentPropUrl, createNativeFeedComponentPropUrl } from './NativeFeedComponentPropUrl';

export type NativeFeedComponentProps = {
  key: string;
  style: ObservableMap<string, string | number>;
  extraProps: ObservableMap<string, string | number | boolean>;
  urlAliases: NativeFeedComponentPropUrl[];
};

export function createNativeFeedComponentProps(json?: Partial<NativeFeedComponentProps>): NativeFeedComponentProps {
  return makeAutoObservable({
    key: (json as any)?.key || UUID(),
    style: observable.map((json as any)?.style || {}),
    extraProps: observable.map((json as any)?.extraProps || {}),
    urlAliases: ((json as any)?.urlAliases || []).map((u: any) => createNativeFeedComponentPropUrl(u)),
  });
}
